export default /* glsl */`
uniform vec2 texelSize;

varying vec2 vUv;
varying vec2 vOffset0;
varying vec2 vOffset1;

void main() {
    vUv = uv;
    vOffset0 = uv + texelSize * vec2(1.0, 0.0);
	vOffset1 = uv + texelSize * vec2(0.0, 1.0);

    gl_Position = vec4(position.xy, 0, 1);
}
`;
